"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KonfektionierungValidator = exports.KonfektionierungValidatorKeys = void 0;
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
// prettier-ignore
class KonfektionierungValidatorKeys {
}
exports.KonfektionierungValidatorKeys = KonfektionierungValidatorKeys;
KonfektionierungValidatorKeys.leitungEinlegenKetteLength = 'LeitungEinlegen: length of kette is invalid: ';
KonfektionierungValidatorKeys.leitungEinlegenLeitungLength = 'LeitungEinlegen: length of leitung is invalid: ';
KonfektionierungValidatorKeys.oeffnungsstegSchliessenNumGlieder = 'OeffnungsstegSchliessen: kette.numGlieder is invalid: ';
KonfektionierungValidatorKeys.oeffnungsstegSchliessenGeschlossen = 'OeffnungsstegSchliessen: kette.geschlossen is invalid: ';
KonfektionierungValidatorKeys.oeffnungsstegSchliessenHalbstegig = 'OeffnungsstegSchliessen: kette.halbstegig is invalid: ';
KonfektionierungValidatorKeys.zugentlastungMontieren = 'ZugentlastungMontieren: zugentlastung.leitung is invalid: ';
KonfektionierungValidatorKeys.verpackungAuflegenKetteLength = 'VerpackungAuflegen: length of kette is invalid: ';
/**
 * The `KonfektionierungValidator` performs validations on the `Konfektionierung`.
 */
class KonfektionierungValidator {
    static calcAndUpdateLeitungEinlegenPossible(kettenLaenge, kettenArtNr, leitung, keyPrefix = '') {
        const v = echain_shared_validation_1.Validation.empty();
        if (!kettenLaenge || kettenLaenge.m === 0) {
            v.add(keyPrefix + KonfektionierungValidatorKeys.leitungEinlegenKetteLength + kettenArtNr);
        }
        if (!(leitung.ueberstandFestpunkt && leitung.ueberstandMitnehmer)) {
            v.add(keyPrefix + KonfektionierungValidatorKeys.leitungEinlegenLeitungLength + leitung.getQuoteArtNr());
        }
        return v;
    }
    static calcAndUpdateOeffnungsstegSchliessenPossible({ halbstegig, numGlieder, geschlossen, chainArtNr, keyPrefix = '', }) {
        const v = echain_shared_validation_1.Validation.empty();
        if (numGlieder == null) {
            v.add(keyPrefix + KonfektionierungValidatorKeys.oeffnungsstegSchliessenNumGlieder + chainArtNr);
        }
        if (geschlossen) {
            v.add(keyPrefix + KonfektionierungValidatorKeys.oeffnungsstegSchliessenGeschlossen + chainArtNr);
        }
        if (halbstegig == null) {
            v.add(keyPrefix + KonfektionierungValidatorKeys.oeffnungsstegSchliessenHalbstegig + chainArtNr);
        }
        return v;
    }
    static calcAndUpdateZugentlastungMontierenPossible(configuration, keyPrefix = '') {
        const v = echain_shared_validation_1.Validation.empty();
        const zugentlastungCountInfo = configuration.getCountOfLeitungenWithZugentlastung();
        if (zugentlastungCountInfo.zesWithoutLeitungen.length) {
            v.add(keyPrefix +
                KonfektionierungValidatorKeys.zugentlastungMontieren +
                zugentlastungCountInfo.zesWithoutLeitungen.map((ze) => ze.getQuoteArtNr()).join(','));
        }
        return v;
    }
    static calcAndUpdateVerpackungAuflegenPossible(kettenLaenge, artNr, keyPrefix = '') {
        const v = echain_shared_validation_1.Validation.empty();
        if (kettenLaenge.m === 0) {
            v.add(keyPrefix + KonfektionierungValidatorKeys.verpackungAuflegenKetteLength + artNr);
        }
        return v;
    }
}
exports.KonfektionierungValidator = KonfektionierungValidator;
//# sourceMappingURL=KonfektionierungValidator.js.map